import React from "react";
import styled from 'styled-components';

const StyledButton = styled.a`
 
    font-size: 18px;
 
    cursor: pointer;
    text-decoration: none;
    background-color: #B6271C;
    color: white;
    font-weight: bold;
   
    transition: box-shadow 0.3s ease; 
    padding: 20px 30px 20px 30px;
     border: 2px solid transparent;
    border-radius: 18px;
    margin-bottom: 60px;
    &:hover {
        border: 2px solid #000 !important;
        box-shadow: 4px 4px black;  
    }
          
    `;

    function Button(props) {
        const { title, onClick } = props; 
        return (
            <StyledButton onClick={onClick} href="https://tong-fei-abbotsford-order-online.square.site/">
                 {title || "ORDER NOW"}
            </StyledButton>
        );
    }
export default Button;